import { render, staticRenderFns } from "./PopupShowInfoImport.vue?vue&type=template&id=994c5a3c&scoped=true"
import script from "./PopupShowInfoImport.vue?vue&type=script&lang=js"
export * from "./PopupShowInfoImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994c5a3c",
  null
  
)

export default component.exports